import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../pipes/pipes.module';
import { MaterialsModalComponent } from './materials-modal.component';
import { FormsModule } from '@angular/forms';
import { InputModalModule } from '../input-modal/input-modal.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, IonicModule, PipesModule, FormsModule, InputModalModule, TranslateModule],
  declarations: [MaterialsModalComponent],
  exports: [MaterialsModalComponent]
})
export class MaterialsModalModule {}
